<template>
  <div style="">
    <hd></hd>
    <div class="contioner">
        <dd v-if="loading" class="text-center">
            <Loading></Loading>
        </dd>
        <el-row v-if="!loading">
        <el-row>
            <el-col :span="24">
                <div class="crumbs"  >
                        <div v-for="(item,index) in tagUrl" :key="index" @click="goBack(item)" class="crubmsList">
                            <span class="decoration">{{item}}</span>
                            <span v-if="index != tagUrl.length-1">/</span>

                        </div>
                        
                    </div>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="14" v-if="!mobiletype">
                <el-col :span="18" >
                    <div class="bigImg" >
                        <div class="bigLoading">
                            <div class="ImgLoading" v-if="showLoading">
                                <img  src="../../assets/images/bizarro-loader-30x30.gif">
                            </div>
                            <img :src="checkImgs" alt="" @load="showImg()" @error="bigImgError()">
                        </div>
                    </div>

                </el-col>
                <el-col :span="4">
                    <div style="text-align: center;margin-bottom:10px;cursor:pointer;" v-if="images&&images.length>9&&sliderIndex!=0" @click="up()"><i class="el-icon-arrow-up" style="font-size:18px;"></i></div>
                    <!-- <div class="smallImg" v-if="choices && choices.length">
                        <div class="imgList" v-for="(item,index) in choices" @mouseover="checkImg(item.image)" :class="{is_select:checkImgs == item.image && !showLoading}">
                            <div class="ImgLoading" v-if="showLoading">
                                <img  src="../../assets/images/bizarro-loader-30x30.gif">
                            </div>
                            <img :src="item.image" alt="">
                        </div>
                        
                    </div> -->
                    <div class="smallImgBox">
                        <div class="smallImg" v-if="images&& images.length" id="sliderSmallImg">
                            <div class="imgList" v-for="(item,index) in images" @mouseover="checkImg(item.image,index)" :class="{is_select:checkImgIndex == index && !item.showLoading}">
                                <div class="ImgLoading" v-if="item.showLoading">
                                    <img  src="../../assets/images/bizarro-loader-30x30.gif">
                                </div>
                                <img :src="item.image" alt="" @load="showSmallImg(item)" @error="imgLoadError(item)">
                            </div>
                            
                        </div>
                    </div>
                    <div style="text-align: center;margin-bottom:10px;cursor:pointer;" v-if="images&&images.length>9&&sliderIndex+9<images.length" @click="down()"><i class="el-icon-arrow-down" style="font-size:18px;"></i></div>
                </el-col>
            </el-col>
            <el-col :span="24" v-if="mobiletype" style="position: relative;">
                <div class="backImg">
                    <div id="slider" class="slider"  v-if="choices && choices.length">
                        <img :key="index" :src="src.image" 
                        v-for="(src,index) in images" 
                        @touchstart="touchstart"
                        @touchmove="touchmove" 
                        @error="imgLoadError(src)"
                        />
                    </div>
                    <div id="slider" class="slider" v-if="!choices || choices.length==0">
                        <img :key="index" :src="src.image" 
                        v-for="(src,index) in images" 
                        @touchstart="touchstart"
                        @touchmove="touchmove" 
                        />
                    </div>
                <div class="pointer" v-if="choices && choices.length"><span v-for="(src,index) in images" :class="{isShow:index == showIndex}"></span></div>
                <div class="pointer" v-if="!choices || choices.length==0"><span v-for="(src,index) in images" :class="{isShow:index == showIndex}"></span></div>
                </div>
            </el-col>
            <el-col :lg="7" :xs="24" class="content">
                <el-col :span="24" style="padding-bottom:30px;">
                    <div class="goodName">
                        <div>
                            <div class="titleBrand" >{{goodDetail.brand_name}}</div>
                            <div class="titleBrand" v-if="goodDetail.brand_name_cn && goodDetail.brand_name_cn !==goodDetail.brand_name">{{goodDetail.brand_name_cn}}</div>
                        </div>
                        <h1>{{goodDetail.name}}</h1>
                        <span>
                            <span class="title">由 <a :href="'/Merchant/'+business.tag" ><span style="color:#666;">{{goodDetail.business_name}}</span></a> 发货</span>
                        </span>
                    </div>
                    <div class="price">
                        <div class="goodprice" v-if="time > new Date(goodDetail.coupon_start.replace(/-/g,'/')).getTime() && time < new Date(goodDetail.coupon_end.replace(/-/g,'/')).getTime()">
                            <div class="">
                                <del v-if="goodDetail.price != '0'">
                                    {{goodDetail.currency_symbol}}{{goodDetail.price}}
                                </del>
                                <del v-if="goodDetail.price == '0'" v-for="(p,index) in goodDetail.price_range.split(',')">
                                    {{goodDetail.currency_symbol}}{{p}}
                                    <div v-if="index == '0'" style="display:inline-block;">
                                    -&nbsp;
                                    </div>
                                </del>
                            </div>
                            <div class="">
                                <span class="discounted" style="padding-right:0 !important;">Now&nbsp;</span>
                                <span v-if="goodDetail.discounted_price != '0'" class="discounted">
                                    {{goodDetail.currency_symbol}}{{goodDetail.discounted_price}}
                                </span>
                                <span v-if="goodDetail.discounted_price == '0'" v-for="(p,index) in goodDetail.discounted_price_range.split(',')" class="discounted">
                                    {{goodDetail.currency_symbol}}{{p}}
                                    <div v-if="index == '0'" class="line">
                                    —
                                    </div>
                                </span>
                                <!-- <span style="font-size:14px;letter-spacing: 0.1px;">80% off</span> -->
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="goodDetail.price != '0'" class="original">
                                {{goodDetail.currency_symbol}}{{goodDetail.price}}
                            </div>
                            <div v-if="goodDetail.price == '0'" v-for="(p,index) in goodDetail.price_range.split(',')" style="display:inline-block;" class="original">
                                {{goodDetail.currency_symbol}}{{p}}
                                <div v-if="index == '0'" style="display:inline-block;">
                                -&nbsp;
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="!goodDetail.specification || !goodDetail.specification.length">
                        <div v-if="choices && choices.length">
                            <el-col :span="24" :class="{moreSpec:choices && choices.length >1}">
                            <el-col :span="3" style="line-height:40px;" v-if="choices && choices.length >1">规格</el-col>
                            <el-col :span="21">
                            <div class="spec" v-if="goodDetail.business_id == 45">
                                <el-select v-model="sku" placeholder="请选择规格"  style="width:100%;" @change="specSelect" v-if="choices && choices.length >1">
                                    <el-option
                                    v-for="(item,index) in choices"
                                    :key="index"
                                    :label="(item.value?item.value:item.color?item.color:item.sku) "
                                    :value="item.sku">
                                    <span style="float: left;width:30px;margin-right:10px;" v-if="item.value && item.value.indexOf('oz') == -1" >
                                        <img style="vertical-align: middle;" :src="item.color_image" alt="">
                                        <div style="display: inline-block;margin-left:5px;">{{item.value}}
                                        </div>
                                        <!-- <div style="display: inline-block;">{{' | '+item.sku}}
                                        </div> -->
                                    </span>
                                    <span style="float: left;width:30px;margin-right:10px;" v-if="!item.value" :class="{outStock:item.outStock}">
                                        <img v-if="item.image" style="vertical-align: middle;width:30px;" :src="item.image" alt="">
                                        <div v-if="item.color">
                                            {{item.color}} |
                                        </div>
                                        <div v-if="item.size">
                                            {{item.size}} |
                                        </div>
                                        <div v-if="item.type">
                                            {{item.type}}
                                        </div>
                                        <!-- <div v-if="item.sku">
                                            {{item.sku}}
                                        </div> -->
                                    </span>
                                    <span style="float: left;width:auto;" v-if="item.value && item.value.indexOf('oz') > -1" :class="{outStock:item.outStock}">{{item.value + ' | ' + item.sku}}
                                    </span>
                                    </el-option>
                                </el-select>
                                <div v-if="choices && choices.length ==1" v-for="(item,index) in choices"  class="onlyOne">
                                    <span style="float: left;margin-right:10px;font-size: 14px;" v-if="item.value && item.value.indexOf('oz') == -1" :class="{outStock:item.outStock}">
                                        <img style="vertical-align: middle;" :src="item.color_image" alt="">
                                        <div style="display: inline-block;margin-left:5px;">{{item.value}}
                                        </div>
                                    </span>
                                    <span style="float: left;margin-right:10px;font-size: 14px;" v-if="!item.value" :class="{outStock:item.outStock}">货号&nbsp;{{item.color?item.color:item.sku}}
                                    </span>
                                    <span style="float: left;width:auto;font-size: 14px;" v-if="item.value && item.value.indexOf('oz') > -1" :class="{outStock:item.outStock}">尺寸&nbsp;{{item.value + ' · 货号 ' + item.sku}}
                                    </span>
                                </div>
                            </div>
                            <div class="spec" v-if="goodDetail.business_id != 45">
                                <el-select v-model="sku" placeholder="请选择规格"  style="width:100%;" @change="specSelect" v-if="choices && choices.length >1">
                                    <el-option
                                    v-for="(item,index) in choices"
                                    :key="index"
                                    :label="item.color_id?item.size_id?'颜色 '+item.color_id+' | '+'尺寸 '+item.size_id:'颜色 '+item.color_id:item.size_id?'尺寸 '+item.size_id:'货号 '+item.sku"
                                    :value="item.sku">
                                    <span style="width:auto;font-size: 14px;" :class="{outStock:item.is_out_of_stock==0? false:true}">
                                        <div v-if="item.color_id">{{'颜色 '+item.color_id}} |</div> 
                                        <div v-if="item.size_id">{{'尺寸 '+item.size_id}}</div> 
                                        <!-- <div v-if="item.sku">{{'货号 '+item.sku}}</div> -->
                                    </span>
                                    </el-option>
                                </el-select>
                                <div v-if="choices && choices.length ==1" v-for="(item,index) in choices"  class="onlyOne">
                                    <span style="float: left;font-size: 14px;" :class="{outStock:item.is_out_of_stock==0? false:true}">
                                        <div v-if="item.color_id">{{'颜色 '+item.color_id}}</div> 
                                        <div v-if="item.size_id"> | {{'尺寸 '+item.size_id}}</div> 
                                        <div v-if="!item.size_id&&!item.color_id">{{'货号 '+item.sku}}</div>
                                        
                                    </span>
                                </div>
                            </div>
                            </el-col>
                            </el-col>
                            <div class="sku" v-if="choices && choices.length >1">
                                <el-col :span="3" >货号</el-col>
                                <el-col :span="20" class="skuText">
                                    {{colorSku}}
                                </el-col>
                            </div>
                        </div>
                        <div v-if="!choices||choices.length==0">
                            <div class="colorSelect" v-if="goodDetail.color_select&&goodDetail.color_select.length>1">
                                <el-col :span="3" class="colorText">颜色</el-col>
                                <!-- <el-col :span="21" class="colorText">{{isSelectColor}}</el-col>
                                <el-col :span="24">
                                    <div class="colorList" v-for="(item,index) in goodDetail.color_select" v-if="item.color_url" :class="{isactive:index==colorIndex}" @click="changeColor(item,index)">
                                        <img :src="item.color_url" alt="">
                                    </div>
                                </el-col> -->
                                <el-col :span="20">
                                    <el-select v-model="newSpec.color" placeholder="请选择颜色" style="width:100%;" @change="changeColor" >
                                        <el-option
                                        v-for="item in goodDetail.color_select"
                                        :key="item.color"
                                        :label="item.color"
                                        :value="item.color"
                                        >
                                        <span class="colorOptions">
                                            <img class="colorImg" v-if="item.color_url" :src="item.color_url" alt="">
                                            <div v-if="item.color">{{item.color}}</div>
                                        </span>
                                        </el-option>
                                    </el-select>
                                </el-col>
                            </div>
                            <div class="colorSelect" v-if="goodDetail.color_select&&goodDetail.color_select.length==1">
                                <el-col :span="3" >颜色</el-col>
                                <el-col :span="20" style="padding-left:15px;color:#666;">
                                    {{goodDetail.color_select[0].color}}
                                </el-col>
                            </div>
                            <div class="sizeSelect" v-if="size_select&&size_select.length">
                                <el-col :span="3" class="sizeText">尺寸</el-col>
                                <el-col :span="20">
                                    <el-select v-model="newSpec.size" style="width:100%;" placeholder="请选择尺寸" @change="changeSize" class="selectSize">
                                        <el-option
                                        v-for="item in size_select"
                                        :key="item"
                                        :label="item"
                                        :value="item">

                                        </el-option>
                                    </el-select>
                                </el-col>
                            </div>
                            <div class="sku">
                                <el-col :span="3" >货号</el-col>
                                <el-col :span="20" class="skuText">
                                    {{colorSku}}
                                </el-col>
                            </div>
                        </div>
                    </div>
                    <div v-if="goodDetail.specification&&goodDetail.specification.length">
                        <div class="colorSelect">
                            <el-col :span="3" class="colorText">颜色</el-col>
                            <!-- <el-col :span="21" class="colorText">{{isSelectColor}}</el-col>
                            <el-col :span="24">
                                <div class="colorList" v-for="(item,index) in goodDetail.color_select" v-if="item.color_url" :class="{isactive:index==colorIndex}" @click="changeColor(item,index)">
                                    <img :src="item.color_url" alt="">
                                </div>
                            </el-col> -->
                            <el-col :span="20">
                                <el-select v-model="newSpec.color" placeholder="请选择颜色" style="width:100%;" @change="changeSpecification" >
                                    <el-option
                                    v-for="item in goodDetail.specification"
                                    :key="item.value"
                                    :label="item.value"
                                    :value="item.value"
                                    >
                                    <span class="colorOptions">
                                        <img class="colorImg" v-if="item.value_url" :src="item.value_url" alt="">
                                        <div v-if="item.value">{{item.value}}</div>
                                    </span>
                                    </el-option>
                                </el-select>
                            </el-col>
                        </div>
                        <div class="sizeSelect" v-if="size_select&&size_select.length">
                            <el-col :span="3" class="sizeText">尺寸</el-col>
                            <el-col :span="20">
                                <el-select v-model="newSpec.size" style="width:100%;" placeholder="请选择尺寸" @change="changeSize" class="selectSize">
                                    <el-option
                                    v-for="item in size_select"
                                    :key="item.value"
                                    :label="item.value"
                                    :value="item.value">

                                    </el-option>
                                </el-select>
                            </el-col>
                        </div>
                        <div class="sku">
                            <el-col :span="3" >货号</el-col>
                            <el-col :span="20" class="skuText">
                                {{colorSku}}
                            </el-col>
                        </div>
                    </div>
                    <el-checkbox v-model="isSingle" v-if="token&&showSingleCheck" :class="{mobileCheck:mobiletype}" style=" clear: both;color:#666666;float: left;margin-bottom:20px;margin-top:10px;">加入下单账户购物车</el-checkbox>
                    <div class="submit" @click="submit()">
                        <el-button class="block btn-14 addCart" type="info" :disabled="outStock">
                            <div>
                                <div class="cartIco"></div>
                                <span class="text">{{outStock?"无 货":"加入购物车"}}</span>
                            </div>
                        </el-button>
                    </div>
                </el-col>
                <el-col :span="24" class="goodInfo">
                    <h6 class="title">商品详情</h6>
                    <el-col :span="24">
                        <div class="content" v-if="goodDetail.business_id != '7'">
                            <div v-html="goodDetail.description" :class="{hide:showmore}">
                            </div>
                            <span @click="showInfo()" class="show">{{showmore?'Show more':'Show less'}}</span>
                        </div>
                        <div class="content"  v-if="goodDetail.business_id == '7'">
                            <div v-if="goodDetail.description.indexOf('description') >-1">
                                <div v-html="JSON.parse(goodDetail.description).description" :class="{hide:showmore}">
                                </div>
                                <ul>
                                    <li v-for="item in JSON.parse(goodDetail.description).features"><span class="point"></span>{{item}}</li>
                                </ul>
                            </div>
                            <div v-else>
                                <div v-html="goodDetail.description" :class="{hide:showmore}">
                                </div>
                            </div>
                            <span @click="showInfo()" class="show">{{showmore?'Show more':'Show less'}}</span>
                        </div>

                    </el-col>
                </el-col>
            </el-col>
        </el-row>
        </el-row>
        <el-dialog v-if="completion" class="el-dialog-sm el-dialog-sm-h3"  :visible.sync="completion" width="90%" @close="completion = false">
            <div class="text-center redirct">
                <p><i class="ico ico-paysucces completion"></i></p>
                    <h1 style="padding: 60px 0 25px;">加入购物车成功</h1>
                </p>
            </div>
        </el-dialog>
    </div>
   <mobilefooter v-if="mobiletype"></mobilefooter>
    <ft v-else class="ft"></ft>
    <GlobalDialogs></GlobalDialogs>
  </div>
</template>
<script>
import api from '../../services/api.js'
import { CURRENCIES } from '../../services/constant'
import hd from '../../components/Header'
import ft from '../../components/Footer'
import Loading from '../../components/Loading'
import mobilefooter from '../../components/mobilefooter'
import GlobalDialogs from '../../components/GlobalDialogs'
let _ = require('lodash')
let $ = require('jQuery')

export default {
    
    name: 'GoodsDetail',
    props: [],
    components: {
        hd: hd,
        ft: ft,
        mobilefooter: mobilefooter,
        Loading: Loading,
    GlobalDialogs: GlobalDialogs
    },
    computed: {
        taskInfo () {
            return this.$store.state.taskInfo
        }
    },
    created (){
        console.log(this.$route.params)
        this.token = this.$localStorage.get('token')
        this.time = new Date().getTime()
        if (document.body.clientWidth < 1153) {
          this.mobiletype = true
        }
        this.getGoodDetail()
        this.getUserInfo()
    },
    data () {
        return {
            colorSku:null,
            isSelectColor:null,
            colorIndex: 0,
            isSubmit: false,
            token: null,
            errorUserPhoto: 'this.src="' + require('../../assets/images/errImg.png') + '"',
            screenWidth: document.body.clientWidth,
            form: {
                name: '',
                website: '',
                color:'',
                size:'',
                spec: '',
                price: '',
                picture: '',
                onekey: 0,
                discounted_price: '',
                number: 1,
                currency: null,
                currency_symbol: null,
            },
            newSpec:{
                color:'',
                size:''
            },
            size_select:[],
            mobiletype: false,
            goodDetail:null,
            choices: null,
            loading: false,
            sku:null,
            tagUrl: [],
            images: null,
            checkImgs: '',
            checkImgIndex:0,
            sliderIndex:0,
            time:'',
            business:'',
            isSingle: false,
            completion: false,
            showLoading: true,
            outStock: false,
            showmore:true,
            startPointX: 0,
            changePointX: 0,
            showIndex: 0,
            showSingleCheck:false,
        }
    },
    mounted() {
        const that = this
        window.onresize = () => {
          return (() => {
            window.screenWidth = document.body.clientWidth
            that.screenWidth = window.screenWidth
          })()
        }
      },
    methods: {
        async getGoodDetail () {
            this.loading = true
            let params = {
                id : this.$route.params.id
            }
            let res = await api.getGoodDetail(this, params)
            if (res.body.status == 'ok') {
                this.loading = false
                this.goodDetail = res.body.result
                this.choices = res.body.result.choices
                this.tagUrl = []
                if(res.body.result.business_id == '45'){
                    if(res.body.result.level_1) {
                        this.tagUrl.push(res.body.result.level_1)
                        if(res.body.result.level_2){
                            this.tagUrl.push(res.body.result.level_2)
                            if(res.body.result.level_3){
                                this.tagUrl.push(res.body.result.level_3)
                                if(res.body.result.level_4){
                                    this.tagUrl.push(res.body.result.level_4)
                                    if(res.body.result.level_5){
                                        this.tagUrl.push(res.body.result.level_5)
                                    }
                                }
                            }
                        }
                    }
                }else{
                    if(res.body.result.level_1) {
                        this.tagUrl.push(res.body.result.level_1_cn)
                        if(res.body.result.level_2){
                            this.tagUrl.push(res.body.result.level_2_cn)
                            if(res.body.result.level_3){
                                this.tagUrl.push(res.body.result.level_3_cn)
                                if(res.body.result.level_4){
                                    this.tagUrl.push(res.body.result.level_4_cn)
                                    if(res.body.result.level_5){
                                        this.tagUrl.push(res.body.result.level_5_cn)
                                    }
                                }
                            }
                        }
                    }
                }

                this.images = []
                _.each(res.body.result.images, item => {
                    this.images.push({image:item, showLoading:true})
                })
                this.showLoading = true
                this.checkImgs = res.body.result.images[0]
                this.form.name = res.body.result.name
                this.form.picture = res.body.result.picture_url
                if(res.body.result.choices && res.body.result.choices.length){
                    this.sku = res.body.result.choices[0].sku
                    // if(res.body.result.color_select && res.body.result.color_select.length){
                    //     _.each(res.body.result.choices,item => {
                    //         _.each(res.body.result.color_select,list => {
                    //             if(item.color_id = list.id) {
                    //                 item.color_id = list.display
                    //                 return false
                    //             }
                    //         })
                    //     })
                    // }
                }
                // console.log(JSON.parse(res.body.result.description))
                if(!this.goodDetail.specification || !this.goodDetail.specification.length){
                    if(this.goodDetail.business_id == 45){
                        if(res.body.result.choices && res.body.result.choices.length){
                            _.each(res.body.result.choices, item => {
                                if(item.availability){
                                    if(item.availability.indexOf('InStock') > -1 || item.availability.indexOf('LimitedAvailability') > -1 || item.availability.indexOf('OnlineOnly') > -1 || item.availability.indexOf('PreOrder') > -1 || item.choices[0].availability.indexOf('PreSale') > -1){
                                        item.outStock = false
                                    }else{
                                        item.outStock = true
                                    }
                                }else{
                                    if(item.is_out_of_stock == 1){
                                        item.outStock = true
                                    }else{
                                        item.outStock = false
                                    }
                                }
                            })
                            if(res.body.result.choices[0].availability){
                                if(res.body.result.choices[0].availability.indexOf('InStock') > -1 || res.body.result.choices[0].availability.indexOf('LimitedAvailability') > -1 || res.body.result.choices[0].availability.indexOf('OnlineOnly') > -1 || res.body.result.choices[0].availability.indexOf('PreOrder') > -1 || res.body.result.choices[0].availability.indexOf('PreSale') > -1){
                                    this.outStock = false
                                }else{
                                    this.outStock = true
                                }
                            }else{
                                if(res.body.result.choices[0].is_out_of_stock == 1){
                                    this.outStock = true
                                }else{
                                    this.outStock = false
                                }
                            }
                            
                            if(res.body.result.choices[0].value && res.body.result.choices[0].value.indexOf('oz') > -1){
                                this.form.spec = res.body.result.choices[0].value + ' | ' + res.body.result.choices[0].sku 
                            }
                            if(res.body.result.choices[0].value && res.body.result.choices[0].value.indexOf('oz') == -1) {
                                this.form.spec = res.body.result.choices[0].value + ' | ' + res.body.result.choices[0].sku
                            }
                            if(!res.body.result.choices[0].value){
                                this.form.spec = ''
                                if(res.body.result.choices[0].color){
                                    this.form.spec = this.form.spec + res.body.result.choices[0].color + ' | '
                                }
                                if(res.body.result.choices[0].size){
                                    this.form.spec = this.form.spec + res.body.result.choices[0].size + ' | '
                                }
                                if(res.body.result.choices[0].type){
                                    this.form.spec = this.form.spec + res.body.result.choices[0].type + ' | '
                                }
                                this.form.spec = this.form.spec + res.body.result.choices[0].sku
                            }
                        }
                    }else{
                        if(res.body.result.choices && res.body.result.choices.length){
                            _.each(res.body.result.choices, item => {
                                if(item.availability){
                                    if(item.availability.indexOf('InStock') > -1 || item.availability.indexOf('LimitedAvailability') > -1 || item.availability.indexOf('OnlineOnly') > -1 || item.availability.indexOf('PreOrder') > -1 || item.choices[0].availability.indexOf('PreSale') > -1){
                                        item.outStock = false
                                    }else{
                                        item.outStock = true
                                    }
                                }else{
                                    if(item.is_out_of_stock == 1){
                                        item.outStock = true
                                    }else{
                                        item.outStock = false
                                    }
                                }
                            })
                            if(res.body.result.choices[0].is_out_of_stock == 1){
                                this.outStock = true
                            }else{
                                this.outStock = false
                            }
                            this.form.spec = res.body.result.choices[0].color_id ? res.body.result.choices[0].size_id ? '颜色 ' + res.body.result.choices[0].color_id + ' | ' + '尺寸 ' + res.body.result.choices[0].size_id + ' | ' + '货号 ' + res.body.result.choices[0].sku : '颜色 ' + res.body.result.choices[0].color_id + ' | ' + '货号 ' + res.body.result.choices[0].sku : res.body.result.choices[0].size_id ? '尺寸 ' + res.body.result.choices[0].size_id + ' | ' + '货号 ' + res.body.result.choices[0].sku : '货号 ' + res.body.result.choices[0].sku
                        }
                    }
                    if(res.body.result.choices && res.body.result.choices.length){
                        if(res.body.result.choices[0].sku){
                            this.colorSku = res.body.result.choices[0].sku
                        }else{
                            this.colorSku = this.goodDetail.sku
                        }
                        this.form.price = res.body.result.choices[0].price
                        this.goodDetail.price = res.body.result.choices[0].price
                        if(res.body.result.choices[0].discounted_price){
                            this.goodDetail.discounted_price = res.body.result.choices[0].discounted_price
                            this.form.discounted_price = res.body.result.choices[0].discounted_price
                        }else{
                            this.form.discounted_price = this.goodDetail.discounted_price
                        }
                    }else{
                        if(this.goodDetail.color_select && this.goodDetail.color_select.length){
                            this.newSpec.color = this.goodDetail.color_select[0].color
                            this.isSelectColor = this.goodDetail.color_select[0].color
                            if(this.goodDetail.color_select[0].sku){
                                this.colorSku = this.goodDetail.color_select[0].sku
                            }else{
                                this.colorSku = this.goodDetail.sku
                            }
                        }else{
                            this.colorSku = this.goodDetail.sku
                        }
                        if(this.goodDetail.available_list && this.goodDetail.available_list.length){
                            this.size_select = []
                            _.each(this.goodDetail.available_list, item => {
                                if(this.newSpec.color == item.color){
                                    this.size_select.push(item.size)
                                }
                            })
                        }else{
                            this.size_select = this.goodDetail.size_select
                        }

                        if(this.size_select && this.size_select.length){
                            this.newSpec.size = this.size_select[0]
                        }
                        if(this.newSpec.size){
                            this.form.spec = this.newSpec.color + ' / ' + this.newSpec.size
                        }else{
                            this.form.spec = this.newSpec.color
                        }
                        console.log(this.newSpec)
                        // if(this.goodDetail.available_list){
                        //     this.outStock = true
                        //     _.each(this.goodDetail.available_list,item => {
                        //         if(this.newSpec.color == item.color && this.newSpec.size==item.size){
                        //             this.outStock = false
                        //             return false
                        //         }
                        //     })
                        // }
                        this.form.price = this.goodDetail.price
                        if(this.goodDetail.discounted_price){
                            this.form.discounted_price = this.goodDetail.discounted_price
                        }
                    }
                }else{
                    this.size_select = []
                    this.images = []
                    this.newSpec.color = this.goodDetail.specification[0].value
                    if(this.goodDetail.specification[0].sku){
                        this.colorSku = this.goodDetail.specification[0].sku
                    }else{
                        this.colorSku = this.goodDetail.sku
                    }
                    if(this.goodDetail.specification[0].image_list && this.goodDetail.specification[0].image_list.length){
                        _.each(this.goodDetail.specification[0].image_list, img => {
                            this.images.push({image:img, showLoading:true})
                        })
                        this.checkImgs = this.goodDetail.specification[0].image_list[0]
                    }
                    if(this.goodDetail.specification[0].has_child == 1){
                        _.each(this.goodDetail.specification[0].child_level, item => {
                            if(item.availability == 1){
                                this.size_select.push(item)
                            }
                        })
                        this.newSpec.size = this.size_select[0].value
                        this.goodDetail.price = this.size_select[0].price
                        this.colorSku = this.size_select[0].sku
                    }
                    this.form.price = this.goodDetail.price
                    if(this.goodDetail.discounted_price){
                        this.form.discounted_price = this.goodDetail.discounted_price
                    }
                }

                this.getBusiness()
            }
            console.log('this.form', this.form)
            console.log('this.choices', this.choices)
        },
        async getGoodDetailAgain(){
            let params = {
                id : this.$route.params.id
            }
            let res = await api.getGoodDetailAgain(this, params)
            if (res.body.status == 'ok') {
                this.loading = false
                this.goodDetail = res.body.result
                this.choices = res.body.result.choices
                this.tagUrl = []
                if(res.body.result.level_1) {
                    this.tagUrl.push(res.body.result.level_1)
                    if(res.body.result.level_2){
                        this.tagUrl.push(res.body.result.level_2)
                        if(res.body.result.level_3){
                            this.tagUrl.push(res.body.result.level_3)
                            if(res.body.result.level_4){
                                this.tagUrl.push(res.body.result.level_4)
                                if(res.body.result.level_5){
                                    this.tagUrl.push(res.body.result.level_5)
                                }
                            }
                        }
                    }
                }
                // this.images = []
                // _.each(res.body.result.images, item =>{
                //     this.images.push({image:item,showLoading:true})
                // })
                // this.showLoading = true
                // this.checkImgs = res.body.result.images[0]
                this.form.name = res.body.result.name
                this.form.picture = res.body.result.picture_url
                if(res.body.result.choices && res.body.result.choices.length){
                    this.sku = res.body.result.choices[0].sku
                    // if(res.body.result.color_select && res.body.result.color_select.length){
                    //     _.each(res.body.result.choices,item => {
                    //         _.each(res.body.result.color_select,list => {
                    //             if(item.color_id = list.id) {
                    //                 item.color_id = list.display
                    //                 return false
                    //             }
                    //         })
                    //     })
                    // }
                }
                console.log('this.choices', this.choices)
            if(!this.goodDetail.specification || !this.goodDetail.specification.length){
                if(this.goodDetail.business_id == 45){
                    if(res.body.result.choices && res.body.result.choices.length){
                         _.each(res.body.result.choices, item => {
                            if(item.availability){
                                if(item.availability.indexOf('InStock') > -1 || item.availability.indexOf('LimitedAvailability') > -1 || item.availability.indexOf('OnlineOnly') > -1 || item.availability.indexOf('PreOrder') > -1 || item.choices[0].availability.indexOf('PreSale') > -1){
                                    item.outStock = false
                                }else{
                                    item.outStock = true
                                }
                            }else{
                                if(item.is_out_of_stock == 1){
                                    item.outStock = true
                                }else{
                                    item.outStock = false
                                }
                            }
                        })
                        if(res.body.result.choices[0].availability){
                            if(res.body.result.choices[0].availability.indexOf('InStock') > -1 || res.body.result.choices[0].availability.indexOf('LimitedAvailability') > -1 || res.body.result.choices[0].availability.indexOf('OnlineOnly') > -1 || res.body.result.choices[0].availability.indexOf('PreOrder') > -1 || res.body.result.choices[0].availability.indexOf('PreSale') > -1){
                                this.outStock = false
                            }else{
                                this.outStock = true
                            }
                        }else{
                            if(res.body.result.choices[0].is_out_of_stock == 1){
                                this.outStock = true
                            }else{
                                this.outStock = false
                            }
                        }
                        if(res.body.result.choices[0].value && res.body.result.choices[0].value.indexOf('oz') > -1){
                            this.form.spec = res.body.result.choices[0].value + ' | ' + res.body.result.choices[0].sku 
                        }
                        if(res.body.result.choices[0].value && res.body.result.choices[0].value.indexOf('oz') == -1) {
                            this.form.spec = res.body.result.choices[0].value + ' | ' + res.body.result.choices[0].sku
                        }
                        if(!res.body.result.choices[0].value){
                            this.form.spec = ''
                            if(res.body.result.choices[0].color){
                                this.form.spec = this.form.spec + res.body.result.choices[0].color + ' | '
                            }
                            if(res.body.result.choices[0].size){
                                this.form.spec = this.form.spec + res.body.result.choices[0].size + ' | '
                            }
                            if(res.body.result.choices[0].type){
                                this.form.spec = this.form.spec + res.body.result.choices[0].type + ' | '
                            }
                            this.form.spec = this.form.spec + res.body.result.choices[0].sku
                        }
                    }
                }else{
                    if(res.body.result.choices && res.body.result.choices.length){
                         _.each(res.body.result.choices, item => {
                            if(item.availability){
                                if(item.availability.indexOf('InStock') > -1 || item.availability.indexOf('LimitedAvailability') > -1 || item.availability.indexOf('OnlineOnly') > -1 || item.availability.indexOf('PreOrder') > -1 || item.choices[0].availability.indexOf('PreSale') > -1){
                                    item.outStock = false
                                }else{
                                    item.outStock = true
                                }
                            }else{
                                if(item.is_out_of_stock == 1){
                                    item.outStock = true
                                }else{
                                    item.outStock = false
                                }
                            }
                        })
                        if(res.body.result.choices[0].is_out_of_stock == 1){
                            this.outStock = true
                        }else{
                            this.outStock = false
                        }
                        this.form.spec = res.body.result.choices[0].color_id ? res.body.result.choices[0].size_id ? '颜色 ' + res.body.result.choices[0].color_id + ' | ' + '尺寸 ' + res.body.result.choices[0].size_id + ' | ' + '货号 ' + res.body.result.choices[0].sku : '颜色 ' + res.body.result.choices[0].color_id + ' | ' + '货号 ' + res.body.result.choices[0].sku : res.body.result.choices[0].size_id ? '尺寸 ' + res.body.result.choices[0].size_id + ' | ' + '货号 ' + res.body.result.choices[0].sku : '货号 ' + res.body.result.choices[0].sku
                    }
                }
                if(res.body.result.choices && res.body.result.choices.length){
                    if(res.body.result.choices[0].sku){
                        this.colorSku = res.body.result.choices[0].sku
                    }else{
                        this.colorSku = this.goodDetail.sku
                    }
                    this.form.price = res.body.result.choices[0].price
                    this.goodDetail.price = res.body.result.choices[0].price
                    if(res.body.result.choices[0].discounted_price){
                        this.goodDetail.discounted_price = res.body.result.choices[0].discounted_price
                        this.form.discounted_price = res.body.result.choices[0].discounted_price
                    }else{
                        this.form.discounted_price = this.goodDetail.discounted_price
                    }
                }else{
                    if(this.goodDetail.color_select && this.goodDetail.color_select.length){
                        this.newSpec.color = this.goodDetail.color_select[0].color
                        this.isSelectColor = this.goodDetail.color_select[0].color
                        if(this.goodDetail.color_select[0].sku){
                            this.colorSku = this.goodDetail.color_select[0].sku
                        }else{
                            this.colorSku = this.goodDetail.sku
                        }
                    }
                    if(this.goodDetail.available_list && this.goodDetail.available_list.length){
                        this.size_select = []
                        _.each(this.goodDetail.available_list, item => {
                            if(this.newSpec.color == item.color){
                                this.size_select.push(item.size)
                            }
                        })
                    }else{
                        this.size_select = this.goodDetail.size_select
                    }

                    if(this.size_select && this.size_select.length){
                        this.newSpec.size = this.size_select[0]
                    }
                    this.form.spec = this.newSpec.color + ' / ' + this.newSpec.size
                    console.log(this.newSpec)
                    // if(this.goodDetail.available_list){
                    //     this.outStock = true
                    //     _.each(this.goodDetail.available_list,item => {
                    //         if(this.newSpec.color == item.color && this.newSpec.size==item.size){
                    //             this.outStock = false
                    //             return false
                    //         }
                    //     })
                    // }
                    this.form.price = this.goodDetail.price
                    if(this.goodDetail.discounted_price){
                        this.form.discounted_price = this.goodDetail.discounted_price
                    }
                }
            }else{
                this.size_select = []
                this.newSpec.color = this.goodDetail.specification[0].value
                if(this.goodDetail.specification[0].sku){
                    this.colorSku = this.goodDetail.specification[0].sku
                }else{
                    this.colorSku = this.goodDetail.sku
                }
                if(!this.images || !this.images.length){
                    if(this.goodDetail.specification[0].image_list && this.goodDetail.specification[0].image_list.length){
                        _.each(this.goodDetail.specification[0].image_list, img => {
                            this.images.push({image:img, showLoading:true})
                        })
                        this.checkImgs = this.goodDetail.specification[0].image_list[0]
                    }
                }
                
                if(this.goodDetail.specification[0].has_child == 1){
                    _.each(this.goodDetail.specification[0].child_level, item => {
                        if(item.availability == 1){
                            this.size_select.push(item)
                        }
                    })
                    this.newSpec.size = this.size_select[0].value
                    this.goodDetail.price = this.size_select[0].price
                    this.colorSku = this.size_select[0].sku
                }
                this.form.price = this.goodDetail.price
                if(this.goodDetail.discounted_price){
                    this.form.discounted_price = this.goodDetail.discounted_price
                }
            }
                // this.getBusiness()
            }
        },
        async getBusiness () {
            let res = await api.getListByWebsite(this, {
                id: this.goodDetail.business_id
            })
            if (res.body.result) {
                this.business = res.body.result[0]
                this.business.business_id = this.business.id,
                this.business.business_name = this.business.name,
                this.business.business_website = this.business.website
                this.form.business = this.business
                this.form.business_id = this.business.business_id
                this.form.business_name = this.business.business_name
                this.form.business_website = this.business.business_website
                this.form.currency = this.goodDetail.currency
                this.form.currency_symbol = this.goodDetail.currency_symbol
                if(this.goodDetail.need_regenerate && ['Nordstrom', 'SephoraUS', 'Macys', 'Puma', 'ConverseUK', 'ConverseUS', 'NordstromRack'].indexOf(this.business.tag) > -1){
                    this.getGoodDetailAgain()
                }
            }
        },
        async getUserInfo () {
            if (window.localStorage.getItem('token')) {
                try {
                let { body } = await api.getUserInfo(this)
                let result = body.result
                if(result.has_single != '1'){
                    this.showSingleCheck = false
                }else{
                    this.showSingleCheck = true
                }
                } catch (e) {
                console.log('eeeeee', e)
                }
            }
        },
        showImg () {
            this.showLoading = false
        },
        showSmallImg(item){
            item.showLoading = false
        },
        bigImgError(){
            this.showLoading = false
            // this.checkImgs = require("../../assets/images/logo@2x.png")
            this.checkImgs = this.business.logo
        },
        imgLoadError(item) {
            item.showLoading = false
            // item.image = require("../../assets/images/logo@2x.png")
            item.image = this.business.logo
        },
        goMerchant(){
          this.$router.push({name: 'Merchant', params: {id: this.business.tag}})
        },
        showInfo () {
            this.showmore = !this.showmore
        },
        checkImg (item, index) {
            this.checkImgs = item
            this.checkImgIndex = index
        },
        up(){
            if(this.sliderIndex == 0){
                console.log(1111)
                return
            }
            this.sliderIndex -= 2
            this.sliderImg()
        },
        down(){
            if(this.sliderIndex + 9 >= this.images.length){
                console.log(2222)
                return
            }
            this.sliderIndex += 2
            this.sliderImg()
        },
        sliderImg(){
            let img = document.getElementById('sliderSmallImg')
            img.style.top = `-${57 * this.sliderIndex}px`
        },
        changeSpecification(color){
            this.newSpec.color = color
            this.checkImgIndex = 0
            this.size_select = []
            this.images = []
            _.each(this.goodDetail.specification, item => {
                if(item.value == color){
                    if(item.image_list && item.image_list.length){
                        _.each(item.image_list, img => {
                            this.images.push({image:img, showLoading:true})
                        })
                        this.checkImgs = item.image_list[0]
                    }
                    if(item.sku){
                        this.colorSku = item.sku
                    }else{
                        this.colorSku = this.goodDetail.sku
                    }
                    if(item.has_child == 1){
                        _.each(item.child_level, list => {
                            if(list.availability == 1){
                                this.size_select.push(list)
                            }
                        })
                        this.newSpec.size = this.size_select[0].value
                        this.goodDetail.price = this.size_select[0].price
                        this.form.price = this.size_select[0].price
                        this.colorSku = this.size_select[0].sku
                    }else{
                        this.newSpec.size = ''
                    }
                    return false
                }
            })
            if(this.newSpec.size){
                this.form.spec = this.newSpec.color + ' / ' + this.newSpec.size
            }else{
                this.form.spec = this.newSpec.color
            }
        },
        changeColor(color){
            // this.isSelectColor = item.color
            this.newSpec.color = color
            // this.colorIndex = index
            _.each(this.goodDetail.color_select, item => {
                if(item.color === color){
                    if(item.sku){
                        this.colorSku = item.sku
                    }else{
                        this.colorSku = this.goodDetail.sku
                    }
                    return false
                }
            })
            
            if(this.goodDetail.available_list){
                this.size_select = []
                _.each(this.goodDetail.available_list, item => {
                    if(this.newSpec.color == item.color){
                        this.size_select.push(item.size)
                    }
                })
            }else{
                this.size_select = this.goodDetail.size_select
            }
            if(this.size_select && this.size_select.length){
                this.newSpec.size = this.size_select[0]
            }else{
                this.newSpec.size = ''
            }
            if(this.newSpec.size){
                this.form.spec = this.newSpec.color + ' / ' + this.newSpec.size
            }else{
                this.form.spec = this.newSpec.color
            }
            // if(this.goodDetail.available_list){
            //     this.outStock = true
            //     _.each(this.goodDetail.available_list,item => {
            //         if(this.newSpec.color == item.color && this.newSpec.size==item.size){
            //             this.outStock = false
            //             return false
            //         }
            //     })
            // }
        },
        changeSize(item){
            console.log(item)
            this.newSpec.size = item
            if(this.goodDetail.specification && this.goodDetail.specification.length){
                _.each(this.size_select, list => {
                    if(item == list.value){
                        this.colorSku = list.sku
                        this.goodDetail.price = list.price
                        this.form.price = list.price
                    }
                })
            }
            if(this.newSpec.size){
                this.form.spec = this.newSpec.color + ' / ' + this.newSpec.size
            }else{
                this.form.spec = this.newSpec.color
            }
            // if(this.goodDetail.available_list){
            //     this.outStock = true
            //     _.each(this.goodDetail.available_list,item => {
            //         if(this.newSpec.color == item.color && this.newSpec.size==item.size){
            //             this.outStock = false
            //             return false
            //         }
            //     })
            // }
        },
        specSelect (item) {
            let choicesList = []
            _.each(this.choices, list => {
                if(list.sku == item){
                   choicesList = list
                    return false
                }
            })
            console.log(choicesList)
            if(this.goodDetail.business_id == 45){
                if(choicesList.availability){
                    if(choicesList.availability.indexOf('InStock') > -1 || choicesList.availability.indexOf('LimitedAvailability') > -1 || choicesList.availability.indexOf('OnlineOnly') > -1 || choicesList.availability.indexOf('PreOrder') > -1 || choicesList.availability.indexOf('PreSale') > -1) {
                        this.outStock = false
                    }else{
                        this.outStock = true
                    }
                }else{
                    if(choicesList.is_out_of_stock == 1){
                        this.outStock = true
                    }else{
                        this.outStock = false
                    }
                }
                
                if(choicesList.value && choicesList.value.indexOf('oz') > -1){
                    this.form.spec = choicesList.value + ' | ' + choicesList.sku 
                }
                if(choicesList.value && choicesList.value.indexOf('oz') == -1) {
                    this.form.spec = choicesList.value + ' | ' + choicesList.sku
                }
                if(!choicesList.value){
                    this.form.spec = ''
                    if(choicesList.color){
                        this.form.spec = this.form.spec + choicesList.color + ' | '
                    }
                    if(choicesList.size){
                        this.form.spec = this.form.spec + choicesList.size + ' | '
                    }
                    if(choicesList.type){
                        this.form.spec = this.form.spec + choicesList.type + ' | '
                    }
                    this.form.spec = this.form.spec + choicesList.sku
                }
            }else{
                if(choicesList.is_out_of_stock == 1){
                        this.outStock = true
                    }else{
                        this.outStock = false
                    }
                    this.form.spec = choicesList.color_id ? choicesList.size_id ? '颜色 ' + choicesList.color_id + ' | ' + '尺寸 ' + choicesList.size_id + ' | ' + '货号 ' + choicesList.sku : '颜色 ' + choicesList.color_id + ' | ' + '货号 ' + choicesList.sku : choicesList.size_id ? '尺寸 ' + choicesList.size_id + ' | ' + '货号 ' + choicesList.sku : '货号 ' + choicesList.sku
            }
            this.form.price = choicesList.price
            this.goodDetail.price = choicesList.price
            if(choicesList.discounted_price){
                this.form.discounted_price = choicesList.discounted_price
                this.goodDetail.discounted_price = choicesList.discounted_price
            }
            this.colorSku = item
        },
        updateTaskInfo () {
            if (this.taskInfo && this.taskInfo.business && this.taskInfo.business.business_name == this.form.business_name) {
                this.taskInfo.business_id = this.form.business_id
                this.taskInfo.business_name = this.form.business_name
                this.taskInfo.business_website = this.form.business_website
                this.taskInfo.currency = this.form.currency
                this.taskInfo.currency_symbol = this.form.currency_symbol
                this.$store.commit('updateTaskInfo', this.taskInfo)
            }else{
                this.$store.commit('clearTaskInfo')
                this.taskInfo.business_id = this.form.business_id
                this.taskInfo.business_name = this.form.business_name
                this.taskInfo.business_website = this.form.business_website
                this.taskInfo.currency = this.form.currency
                this.taskInfo.currency_symbol = this.form.currency_symbol
                this.$store.commit('updateTaskInfo', this.taskInfo)
            }
        },
        async submit () {
             let token = this.$localStorage.get('token')
            if(!token){
                this.dialogFormVisible = false
                if (window.innerWidth <= 768) {
                this.$store.commit('showGlobalDialog', 'loginVisible')
                } else {
                window.location.href = '/login'
                }
                return
            }
            if(this.outStock) {
                return
            }
            if(!this.form.price){
                this.form.price = this.goodDetail.price
            }
            if(this.time > new Date(this.goodDetail.coupon_start.replace(/-/g, '/')).getTime() && this.time < new Date(this.goodDetail.coupon_end.replace(/-/g, '/')).getTime()){

            }else{
                this.form.discounted_price = this.form.price
            }
            console.log('this.form', this.form)
            console.log('this.isSingle', this.isSingle)
            if(this.goodDetail.url){
                this.form.website = this.goodDetail.url
            }else{
                this.form.website = window.location.href
            }
            let flag = false
            if(this.isSingle) {
                this.taskInfo.currency = this.form.currency
                this.taskInfo.currency_symbol = this.form.currency_symbol
                this.updateTaskInfo()
                this.form.id = +new Date()
                this.form.good_id = this.goodDetail.id
                if(!this.form.discounted_price) {
                    this.form.discounted_price = this.form.price
                }
                this.taskInfo.business = this.business
                this.taskInfo.goods_list = this.taskInfo.goods_list || []
                if(this.taskInfo.goods_list.length > 0) {
                    _.each(this.taskInfo.goods_list, item => {
                        if(item.business_website == this.form.business_website && item.name == this.form.name && item.spec == this.form.spec && item.price == this.form.price && item.discounted_price == this.form.discounted_price && item.picture == this.form.picture){
                        item.number = Number(item.number) + 1
                        flag = true
                        this.$store.commit('updateTaskInfo', this.taskInfo)
                        this.completion = true
                        }
                    })
                }
                if(flag){
                    return
                }
                this.taskInfo.goods_list.push(this.form)
                this.taskInfo.goods_list = _.orderBy(this.taskInfo.goods_list, ['id'], ['desc'])
                this.$store.commit('updateTaskInfo', this.taskInfo)
                this.completion = true
            }else{
                if(this.isSubmit) {
                    return
                }
                this.isSubmit = true
                this.form.good_id = this.goodDetail.id
                if(!this.form.discounted_price) {
                    this.form.discounted_price = this.form.price
                }
                try {
                let cartList = await api.getCartList(this)
                if(cartList.body.result) {
                let list = cartList.body.result
                _.each(list, async item => {
                    if(item.status == '0' && item.business_name == this.form.business_name && item.business_website == this.form.business_website && item.name == this.form.name && item.spec == this.form.spec && item.price == this.form.price && item.discounted_price == this.form.discounted_price && item.picture_url == this.form.picture) {
                        console.log(1)
                        item.currency = this.form.currency
                        item.currency_symbol = this.form.currency_symbol
                        item.number = Number(item.number) + 1
                        flag = true
                        let res = await api.post(this, {
                        path: 'cart.php',
                        api: 'update',
                        data: [item],
                        })
                        if (res.body.status == 'ok') {
                            this.completion = true
                            this.isSubmit = false
                        }
                    }
                })
                if(flag) {
                    return
                }
                let res = await api.post(this, {
                    path: 'cart.php',
                    api: 'add',
                    data: [this.form],
                    })
                if (res.body.status == 'ok') {
                    this.completion = true
                    this.isSubmit = false
                }
                }else{
                    let res = await api.post(this, {
                        path: 'cart.php',
                        api: 'add',
                        data: [this.form],
                    })
                    if (res.body.status == 'ok') {
                        this.completion = true
                        this.isSubmit = false
                    }
                }
                }catch(e){
                    console.log('cartList', e)
                    if(e.status == '401'){
                        this.$localStorage.remove('token')
                        if (window.innerWidth <= 768) {
                            this.$store.commit('showGlobalDialog', 'loginVisible')
                        } else {
                            window.location.href = '/login'
                        }
                    }
                }
            }
        },
        show(index){
            this.changePointX = this.startPointX
            let slider = document.getElementById('slider')
            slider.style.marginLeft = `-${385 * index}px`
        },
        touchstart(e){
            this.startPointX = e.changedTouches[0].pageX
        },
        touchmove(e){
            if(this.startPointX == this.changePointX){
                return
            }
            let currPointX = e.changedTouches[0].pageX
            let leftSlide = this.startPointX - currPointX
            if(leftSlide > 30 && this.showIndex < this.images.length - 1){
                this.show(++this.showIndex)
            }else if(leftSlide < -30 && this.showIndex > 0){
                this.show(--this.showIndex)
            }
        },
        goBack (item) {
            if(this.tagUrl.indexOf(item) < this.tagUrl.length - 1){
                this.tagUrl.splice(this.tagUrl.indexOf(item) + 1, this.tagUrl.length - 1 - this.tagUrl.indexOf(item))
            }
            if(this.goodDetail.business_id == 45){
                this.$router.push({name:'Goods', params:{id: 45}, query:{page:1, level:this.tagUrl.join(',')}})
            }else{
                this.$router.push({name:'NormalProduct', params:{id: this.goodDetail.business_id}, query:{page:1, level:this.tagUrl.join(',')}})
            }
        },
        findBybrand () {
            if(this.goodDetail.business_id == 45){
                this.$router.push({name:'Goods', params:{id: 45}, query:{page:1, brand:[this.goodDetail.brand_name]}})
            }else{
                this.$router.push({name:'NormalProduct', params:{id: this.goodDetail.business_id}, query:{page:1, brand:[this.goodDetail.brand_name]}})
            }
        }
    },
    watch: {
        screenWidth (val) {
          if (!this.timer) {
            this.screenWidth = val
            console.log(val)
            if (val < 1153) {
              this.mobiletype = true
            } else {
              this.mobiletype = false
            }
            this.timer = true
            let that = this
            setTimeout(function () {
              // that.screenWidth = tha t.$store.state.canvasWidth
              that.timer = false
            }, 400)
          }
        },
        $route (to, from) {
              console.log(to)
              if(to.params.id != from.params.id){
                  this.getGoodDetail()
              }
        }
    }
    
}
// function notfund () {
//         var img = event.srcElement;
//         img.src = this.errorUserPhoto;
//         img.onerror = null; //解绑onerror事件
//     }
</script>
<style scoped lang="scss">
.contioner {
    margin: 145px auto 0;
    max-width: 1500px;
    padding: 0 100px;
    a:hover {
        text-decoration: underline;
        color: #666;
    }
    .crumbs {
        padding: 35px 40px 18px;
        color: #888 !important;
        .crubmsList {
            display: inline-block;
            margin-left: 5px;
            font-size: 12px !important;
            cursor: pointer;
            .decoration:hover {
                text-decoration: underline;
            }
        }

    }

    .bigImg{
        // height: 720px;
        width: 100%;
        text-align: center;
        position: relative;
        overflow: hidden;
        text-align: center;
        .bigLoading{
            height:500px;
            width:500px;
            margin: 10px auto;
            position: relative;
            overflow: hidden;
            // margin-top: 135px;
            .ImgLoading {
                position: absolute;
                top: 0;
                left: 0;
                display:inline-block;
                background-color: #F3F3F9 !important;
                height:500px;
                width:500px;
                img {
                    height: 50px;
                    width: 50px;
                    margin-top: 225px;
                }
            }
            img {
                // width: 100%;
                // position: absolute;
                // left: 0;
                // top: 50%;
                // -webkit-transform: translateY(-50%);
                // transform: translateY(-50%);
                height: 500px;
                width: 500px;
                object-fit: contain;
            }
        }
        
    }
    .smallImgBox{
        position: relative;
        height: 513px;
        overflow: hidden;
    }
    .smallImg {
        position: absolute;
        top: 0;
        left: 0;
        overflow: hidden;
        margin: 0 40px;
        .imgList {
            display: inline-block;
            margin-bottom: 10px;
            position: relative;
            height: 47px;
            width: 47px;
            &.is_select {
                border: 1px solid #333 !important;
            }
            img {
                height: 45px;
                width: 45px;
                object-fit: contain;
            }
            .ImgLoading {
                position: absolute;
                top: 0;
                left: 0;
                display:inline-block;
                background-color: #F3F3F9 !important;
                height:45px;
                width:45px;
                margin-bottom: 21px;
                text-align: center;
                img {
                    height: 30px;
                    width: 30px;
                    margin-top: 10px;
                }
            }
        }
    }
    .backImg{
        margin: 0 auto 40px;
        width: 375px;
        overflow: hidden;
    }
    .pointer {
        // position: absolute;
        // bottom: 20px;
        // left: 170px;
        text-align: center;

        span {
            display: inline-block;
            border-radius: 50%;
            height: 5px;
            width: 5px;
            background: #666;
            margin-right: 10px;
            &.isShow {
                background: #222 !important;
            }
        }
    }
    .slider{
        white-space: nowrap;
        transition: 1s; 
        overflow: hidden;
        min-width: 375px;
        height: 375px;
        
        img{
            width: 375px;
            height: 375px;
            display: inline;
            margin-right: 10px;
            object-fit: contain;
        }
    }
    .goodName {
        .titleBrand {
            font-weight: 700;
            font-size: 16px;
            margin-bottom: 10px;
            display: inline-block;
            color: #333;
            // cursor: pointer;
            // &:hover {
            //     text-decoration: underline;
            //     text-decoration-color: #666;
            // }
        }
        h1 {
            font-size: 26px !important;
            line-height: 30px !important;
            letter-spacing: 0.1px !important;
            font-weight: 500;
            color: #333;
            padding-bottom: 15px;
        }
        .title {
            font-size: 15px !important;
            letter-spacing: 0.1px !important;
            color: #666 !important;
            margin-bottom: 10px;
            display: inline-block;
        }
    }
    .price {
        padding-bottom: 25px !important;
        padding-top: 25px !important;
        
        .goodprice {
            del {
                display: inline-block;
                font-size: 16px !important;
                color: #B0B4BF !important;
                margin-bottom: 10px ;
            }
            .discounted {
                font-size: 24px !important;
                letter-spacing: 0.1px !important;
                margin: 0px !important;
                color: #000 !important;
                padding-right: 8px !important;
            }

            .line {
                display: inline-block;
                position: relative;
                top: -4px;
                right: -4px;
            }
        }
        .original {
            font-size: 18px;
            letter-spacing: 0.1px;
            color: #333;
            font-weight: 500;
        }
    }
    .moreSpec{
        margin-bottom: 10px;
    }
    .spec {
        overflow: hidden;

        .onlyOne {
            overflow: hidden;
            min-height: 30px;
            padding:0;
            color: #808080;
            
            .outStock {
                color: #c0c4cc !important;
            }

            div{
                display: inline-block;
            }
        }
    }
    .colorSelect{
        overflow: hidden;
        margin-bottom: 10px;
        // height: 24px;
        .colorText{
            line-height: 40px;
        }
        .colorList{
            display: inline-block;
            height: 20px;
            width: 20px;
            margin-right: 10px;
            margin-bottom: 10px;
            cursor: pointer;
            // box-sizing: content-box;
            vertical-align: middle;
            &.isactive{
                border: 2px solid #386BF1;
            }
            img {
                width: 100%;
            }
        }
    }
    .sizeSelect{
        margin-bottom: 10px;
        overflow: hidden;
        .sizeText{
            line-height: 40px;
        }
    }
    .sku {
        margin-bottom: 10px;
        // overflow: hidden;
        display: inline-block;
        width: 100%;
        .skuText {
            color: #666;
            padding-left: 15px;
        }
    }
    .mobileCheck {
        padding: 0px 15px;
        white-space: normal;
    }
    .submit {
        margin-top: 10px;
        clear: both;
        .addCart {
            height: 45px !important;
            border-radius: 3px !important;
            background-color: #333 ;
            text-align: center;
            font-size: 12px;
            width: 100%;
            border: 0;
            padding: 0;
            .cartIco {
                display: inline-block !important;
                position: relative !important;
            }
            .cartIco::before {
                background: url('../../assets/images/cart_icon.svg') no-repeat scroll center center !important;
                content: "" !important;
                display: inline-block !important;
                height: 25px !important;
                width: 25px !important;
                position: relative !important;
                margin-right: 10px !important;
                top: -3px !important;
                vertical-align: middle !important;
                box-sizing: border-box;
            }
            .text {
                font-size: 15px !important;
                letter-spacing: 0.1px !important;
                display: inline-block !important;
                color: #FFF !important;
                text-transform: none !important;
                margin-top: 5px;
            }
        }
    }
    .redirct {
            font-size:24px;
            line-height:33px;
            margin-top: 54px;
            padding-bottom: 70px;

            .completion {
                background-image: url('../../ico/blueSucccess@2x.png');
                background-position: 0 0;
                background-size: contain;
            }
        }

        .goodInfo {
            
            .title {
                font-size: 16px !important;
                height: 60px !important;
                line-height: 60px !important;
            }
            .content {
                // max-height: 70px;
                position: relative;
                color: #666;
                font-size: 14px !important;
                letter-spacing: 0.1px !important;
                line-height: 19px !important;
                text-overflow: ellipsis !important;
                white-space: normal !important;
                .hide {
                    max-height: 75px;
                    overflow: hidden !important;
                }

                .show {
                    position: absolute;
                    right: 0;
                    bottom: -12px;
                    border-bottom: 2px solid #808080 !important;
                    color: #808080 !important;
                    cursor: pointer !important;
                    font-size: 12px !important;
                    font-weight: 500 !important;
                    line-height: 12px !important;
                }

                .point {
                    display: inline-block;
                    width: 5px;
                    height: 5px;
                    vertical-align: middle;
                    margin-right: 10px;
                    margin-left: 5px;
                    border-radius: 50%;
                    background: #333;
                }
            }
        }
        .outStock {
            color: #c0c4cc !important;

            div{
                color: #c0c4cc !important;

            }
        }
}
    @media screen and (max-width:1152px){
        .contioner {
            padding: 0;
            margin: 50px auto 50px;

            .crumbs {
                padding: 25px 10px 18px;
            }
            .content {
                padding: 0 10px;
            }
        }   
        
    }
</style>



// WEBPACK FOOTER //
// src/pages/goods/GoodsDetail.vue